import type { Conf } from 'src/global';
import {
    addTags,
    getZe,
    handleFeaturesSupression,
    monitorUserEvent,
    setupHelpCenterTitle,
} from 'src/util';

import loadPaid from './paid';
import loadFreeInWordspace from './sales-in-workspace';

const SUGGESTION_MAP: { [key: string]: string } = {
    '/home/published/.*/links': 'home_links',
    '/home/published/.*#publication-home-article-stories': 'home_as',
    '/home/published/.*/gif': 'home_gif',
    '/home/published/.*/embed': 'home_embed',
    '/home/published/.*/fsreader': 'home_fullscreen',
    '/home/published/.*/stack': 'home_stacks',
    '/home/publisher': 'home-publisher',
    '/home/published': 'home-published',
    '/home/stories/published': 'home_as',
    '/home/statistics': 'home_stats',
};

export const moveZdOutWindow = () => {
    const style = document.createElement('style');
    style.textContent = 'iframe#launcher {visibility: hidden;}';
    document.head.appendChild(style);
};

export const loadSupport = (conf: Conf) => {
    const zE = getZe();

    const setupSuggestion = () => {
        let label = 'home-publisher';
        for (const key in SUGGESTION_MAP) {
            if (SUGGESTION_MAP.hasOwnProperty(key)) {
                if (location.href.match(key)) {
                    label = SUGGESTION_MAP[key];
                    break;
                }
            }
        }
        zE('webWidget', 'helpCenter:setSuggestions', { labels: [label] });
    };

    handleFeaturesSupression(['answerBot', 'talk']);
    monitorUserEvent(conf);
    setupHelpCenterTitle();
    zE.hide();
    setupSuggestion();
    addTags(['support_pages'], conf);

    if (conf.isPaidUser || conf.isTeamUser) {
        loadPaid(conf);
    } else {
        loadFreeInWordspace(conf);
    }
};

export default loadSupport;
